import {Button, Menu, MenuItem} from '@material-ui/core';
import ArrowDown from '@material-ui/icons/KeyboardArrowDown';
import AgentDocumentationRoutes from 'Agent/AgentDocumentation/AgentDocumentationRouteConstants';
import React from 'react';
import {useSelector} from 'react-redux';
import {useHistory} from 'react-router-dom';
import MenuStateProvider from 'Shared/components/MenuStateProvider';
import RequireScope from 'Shared/components/RequireScope';
import {Scope} from 'Shared/constants/Scope';
import {selectUserScopes} from 'Users/selectors/userProfileSelectors';

const DocumentationMenu = () => {
  const history = useHistory();
  const scopes = useSelector(selectUserScopes);

  return (
    <RequireScope scopes={scopes} scope={Scope.AgentResources}>
      <MenuStateProvider>
        {({open, close, anchor}) => (
          <>
            <Button
              id="administration-menu-button"
              className="my-access-menu"
              variant="text"
              onClick={event => open(event.currentTarget)}
              aria-haspopup="true"
              aria-controls="documntation-menu"
              aria-expanded={Boolean(anchor)}
            >
              Documentation
              <ArrowDown />
            </Button>
            <Menu
              anchorOrigin={{vertical: 'bottom', horizontal: 'center'}}
              transformOrigin={{vertical: 'top', horizontal: 'center'}}
              getContentAnchorEl={null}
              onClose={close}
              open={Boolean(anchor)}
              anchorEl={anchor}
              id="documentation-menu"
            >
              <MenuItem
                id="accounts-my-allstate-option"
                className="my-access-menu__item"
                onClick={() => {
                  history.push(AgentDocumentationRoutes.ENROLL_MY_WAY);
                  close();
                }}
              >
                EnrollMyWay Voice Upload
              </MenuItem>
              <MenuItem
                className="my-access-menu__item"
                id="agent-administration-option"
                onClick={() => {
                  history.push(AgentDocumentationRoutes.DIRECT_DEPOSIT_INFORMATION);
                  close();
                }}
              >
                Direct Deposit Information
              </MenuItem>
              <MenuItem
                className="my-access-menu__item"
                id="agent-administration-option"
                onClick={() => {
                  history.push(AgentDocumentationRoutes.PRODUCER_COMPLIANCE_POLICY);
                  close();
                }}
              >
                Producer Compliance Policy
              </MenuItem>
            </Menu>
          </>
        )}
      </MenuStateProvider>
    </RequireScope>
  );
};

export default DocumentationMenu;
